import { z } from "zod";

/**
 * Validated, typed access to build-time environment. Fails fast at startup if a
 * variable is malformed, instead of failing deep inside a request.
 * Only VITE_* variables are exposed by Vite; never put secrets here.
 */
const envSchema = z.object({
  /** API origin. Empty string = same origin (dev proxy / nginx). */
  VITE_API_ORIGIN: z.string().default(""),
  VITE_APP_NAME: z.string().min(1).default("Groundwork EGC"),
  // Where the policies live (the marketing site). Links in the app point there.
  VITE_SITE_ORIGIN: z.string().default("https://groundworkegc.com"),
  MODE: z.enum(["development", "production", "test"]).default("development"),
  DEV: z.boolean().default(false),
  PROD: z.boolean().default(false),
});

const parsed = envSchema.safeParse(import.meta.env);
if (!parsed.success) {
  throw new Error(`Invalid environment: ${JSON.stringify(parsed.error.flatten().fieldErrors)}`);
}

export const env = Object.freeze(parsed.data);
